import axios from 'axios'
import { Result, ok, err } from 'neverthrow'
import { HttpResponseData, HttpRequest } from '../interfaces/http'
import { CoreErrorTypes } from '../interfaces/error/CoreErrorTypes'
import { isAxiosError } from './axios/isAxiosError'
import { axiosErrorToApiError } from './axios/axiosErrorToApiError'

type errorsReturned = CoreErrorTypes
type Response = Promise<Result<HttpResponseData, errorsReturned>>

/**
 * The library's method for making a http request.
 *
 * It wraps the underlying implementation (axios
 * in this case).
 *
 *
 * @param url
 * @param data
 * @param config
 */
export const makeHttpRequest = async (request: HttpRequest): Response => {
  try {
    const resp = await axios(request)
    return ok(resp.data)
  } catch (e) {
    if (isAxiosError(e)) {
      // console.log('response:')
      // console.log(e)
      const error = axiosErrorToApiError(e)
      return err(error)
    }
    throw e
  }
}
